export default __webpack_public_path__ + "static/media/25.16938d89.jpg";